import React from 'react';
import {createBrowserRouter, RouteObject} from 'react-router-dom';
import App from "../../App";
import Home from "../layout/pages/Home";
import ProtectedRoute from "./ProtectedRoutes";
import TitleDetails from "../layout/pages/TitleDetails";
import SectionTemplates from "../layout/pages/SectionTemplates";
import Users from "../layout/pages/Users";
import SubscriptionCallback from "../layout/pages/SubscriptionCallback";
import TitleBank from "../layout/pages/TitleBank";
import Dashboard from '../layout/pages/Dashboard';
import Subscription from "../layout/pages/Subscription";
import TemplateDetails from "../layout/pages/TemplateDetails";
import CompletedOrders from "../layout/pages/CompletedProjects";
import TitleSummaryReport from '../layout/pages/TitleSummaryReport';
import LineListReport from '../layout/pages/LineListReport';
import MarketplaceManagement from '../layout/pages/MarketplaceManagement';
import Marketplace from '../layout/pages/Marketplace';
import BillingCallback from "../layout/pages/BillingCallback";

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '',
        element: <Home />
      },
      {
           path: 'dashboard',
           element: (
               <ProtectedRoute>
                  <Dashboard />
               </ProtectedRoute>
           )
      },
      {
          path: 'completed-files',
          element: (
              <ProtectedRoute>
                  <CompletedOrders />
              </ProtectedRoute>
          )
      },
      {
          path: 'title-bank',
          element: (
              <ProtectedRoute>
                  <TitleBank />
              </ProtectedRoute>
          )
      },
      {
        path: 'organization/:organizationId/title/:titleId',
        element: (
            <ProtectedRoute>
              <TitleDetails />
            </ProtectedRoute>
        )
      },
      {
        path: 'subscription',
        element: <Subscription />,
      },
      {
        path: 'subscription/:status',
        element: <SubscriptionCallback />,
      },
      {
            path: 'billing/tokens/success',
            element: <BillingCallback />,
      },
      {
          path: 'section-templates',
          element: (
              <ProtectedRoute>
                  <SectionTemplates />
              </ProtectedRoute>
          )
      },
      {
          path: 'users',
          element: (
              <ProtectedRoute>
                  <Users />
              </ProtectedRoute>
          )
      },
      {
          path: 'template-details',
          element: (
              <ProtectedRoute>
                  <TemplateDetails />
              </ProtectedRoute>
          )
      },
      {
        path: 'title-summary-report',
        element: (
            <ProtectedRoute>
                <TitleSummaryReport />
            </ProtectedRoute>
        )
    },
    {
        path: 'line-list-report',
        element: (
            <ProtectedRoute>
                <LineListReport />
            </ProtectedRoute>
        )
    },
    {
        path: 'marketplace-management',
        element:(
            <ProtectedRoute>
                <MarketplaceManagement />
            </ProtectedRoute>
        )
    },
      {
        path: 'marketplace',
        element: (
            <ProtectedRoute>
                <Marketplace />
            </ProtectedRoute>
        )
    }
    ]
  }
];

export const router = createBrowserRouter(routes);
